import { motion } from "framer-motion";

/**
 * Reveal — subtle scroll-triggered fade + rise.
 * Usage: <Reveal delay={0.1}>...</Reveal>
 */
export default function Reveal({
  children,
  delay = 0,
  y = 20,
  duration = 0.55,
  once = true,
  as = "div",
  className = "",
  ...rest
}) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration, delay, ease: [0.22, 0.61, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}

/**
 * Stagger — wraps a list. Direct children should be <RevealItem />.
 */
export function Stagger({ children, delayChildren = 0.05, staggerChildren = 0.08, className = "", ...rest }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-40px" }}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren, delayChildren } },
      }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function RevealItem({ children, y = 20, className = "", ...rest }) {
  return (
    <motion.div
      variants={{
        hidden: { opacity: 0, y },
        show: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.5, ease: [0.22, 0.61, 0.36, 1] },
        },
      }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}
